import React, { Suspense } from 'react';
import { ManagedPopup } from 'js/components/common/Popup';
import { useOnClose } from 'js/components/common/PopupManager';
import { GamblingSessionLimits } from 'js/components/main/GamblingSessionLimits';

import * as Types from './types';

import style from './GamblingSessionLimitsPopup.scss';

export const GamblingSessionLimitsPopup: React.FC<Types.IGamblingSessionLimitsPopupParams> = ({ id, onSuccessLimitsSet }) => {
    const closePopup = useOnClose(id);

    return (
        <ManagedPopup
            id={id}
            isModal
            className={style.container}
            layerClassNames={{ layout: style.layout }}
            title="playtech.mobile.system.gamblingSessionLimits.title"
        >
            <Suspense fallback="">
                <GamblingSessionLimits
                    closePopup={closePopup}
                    isActionDialogCheckDisabled
                    onSuccessLimitsSet={onSuccessLimitsSet}
                />
            </Suspense>
        </ManagedPopup>
    );
};
